import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-48718a7a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "comment"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  "class": "content-box"
};
var _hoisted_4 = {
  "class": "meta-box"
};
var _hoisted_5 = {
  "class": "user-popover-box"
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  "class": "content"
};
var _hoisted_8 = {
  key: 0,
  "class": "reply"
};
var _hoisted_9 = ["title"];
var _hoisted_10 = {
  key: 1,
  "class": "img-box"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  "class": "reply-stat"
};
var _hoisted_13 = ["title", "datetime"];

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "·", -1);
});

var _hoisted_15 = {
  key: 1,
  "class": "action-box"
};
var _hoisted_16 = {
  "aria-hidden": "true",
  viewBox: "0 0 20 20",
  "class": "icon like-icon"
};
var _hoisted_17 = {
  fill: "none",
  "fill-rule": "evenodd"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h20v20H0z"
  }, null, -1);
});

var _hoisted_19 = ["stroke", "fill"];

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    "class": "icon comment-icon"
  }, [/*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/_createElementVNode("path", {
    stroke: "#8A93A0",
    "stroke-linejoin": "round",
    d: "M10 17c-4.142 0-7.5-2.91-7.5-6.5S5.858 4 10 4c4.142 0 7.5 2.91 7.5 6.5 0 1.416-.522 2.726-1.41 3.794-.129.156.41 3.206.41 3.206l-3.265-1.134c-.998.369-2.077.634-3.235.634z"
  })])], -1);
});

var _hoisted_21 = {
  "class": "action-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Markdown = _resolveComponent("Markdown");

  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass(["comment-item", {
      'sub-comment-item': $options.isSubComment
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    "class": "avatar",
    src: $props.comment.user.avatar || '',
    onError: _cache[0] || (_cache[0] = function (e) {
      return e.target.classList.add('error');
    })
  }, null, 40, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "userMeta", {}, function () {
    return [_createElementVNode("div", _hoisted_5, [$props.comment.user ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.comment.user.name + ($props.comment.user.author === true ? _ctx.$t("label.author") : "")), 1)) : _createCommentVNode("", true)])];
  }, true)]), _createElementVNode("div", _hoisted_7, [$props.comment.reply ? (_openBlock(), _createElementBlock("span", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.$t("label.reply")) + " ", 1), _createElementVNode("span", {
    "class": "reply-target",
    title: $props.comment.reply.email
  }, _toDisplayString($props.comment.reply.name + "："), 9, _hoisted_9)])) : _createCommentVNode("", true), _createVNode(_component_Markdown, {
    text: $props.comment.content
  }, null, 8, ["text"]), $props.comment.imgSrc ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("img", {
    src: $props.comment.imgSrc || '',
    onError: _cache[1] || (_cache[1] = function (e) {
      return e.target.classList.add('error');
    })
  }, null, 40, _hoisted_11)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("time", {
    title: $options.formatTime($props.comment.createAt, true),
    datetime: $props.comment.createAt
  }, _toDisplayString($options.dateDiff($props.comment.createAt)), 9, _hoisted_13), $props.user.author === true ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": "delete",
    onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
      return _ctx.$emit('comment-delete', {
        id: $props.id,
        comment: $props.comment,
        parent: $props.parent
      });
    }, ["stop"]))
  }, [_hoisted_14, _createTextVNode(_toDisplayString(_ctx.$t("label.delete")), 1)])) : _createCommentVNode("", true), $props.user.name ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", {
    "class": _normalizeClass(["like-action action", {
      active: $props.comment.liked
    }]),
    onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
      return _ctx.$emit('comment-like', {
        id: $props.id,
        comment: $props.comment
      });
    }, ["stop"]))
  }, [(_openBlock(), _createElementBlock("svg", _hoisted_16, [_createElementVNode("g", _hoisted_17, [_hoisted_18, _createElementVNode("path", {
    stroke: $props.comment.liked ? '#37C700' : '#8A93A0',
    "stroke-linejoin": "round",
    fill: $props.comment.liked ? '#37c700' : 'none',
    d: "M4.58 8.25V17h-1.4C2.53 17 2 16.382 2 15.624V9.735c0-.79.552-1.485 1.18-1.485h1.4zM11.322 2c1.011.019 1.614.833 1.823 1.235.382.735.392 1.946.13 2.724-.236.704-.785 1.629-.785 1.629h4.11c.434 0 .838.206 1.107.563.273.365.363.84.24 1.272l-1.86 6.513A1.425 1.425 0 0 1 14.724 17H6.645V7.898C8.502 7.51 9.643 4.59 9.852 3.249A1.47 1.47 0 0 1 11.322 2z"
  }, null, 8, _hoisted_19)])])), _withDirectives(_createElementVNode("span", {
    "class": "action-title"
  }, _toDisplayString($props.comment.likes), 513), [[_vShow, $props.comment.likes]])], 2), _createElementVNode("div", {
    "class": "comment-action action",
    onMousedown: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
      return _ctx.$emit('comment-reply', $props.id);
    }, ["prevent"])),
    onClick: _cache[5] || (_cache[5] = _withModifiers(function () {}, ["prevent"]))
  }, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("label.reply")), 1)], 32)])) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "default", {
    id: $props.id
  }, undefined, true), _renderSlot(_ctx.$slots, "subList", {
    parentId: $props.id
  }, undefined, true)])])], 2);
}